// extracted by mini-css-extract-plugin
export default {"buttoms":"Dashboard_buttoms__U287c","button":"Dashboard_button__jOGsU","addToCart":"Dashboard_addToCart__OfTrK"};